module.exports = __webpack_public_path__ + "images/smartphone-screen-4_70c208151c42e7f2ca5694f2ef357d80.png";